import {
  initialState,
  Actions,
  State,
  GET_PLAN,
  GET_PLAN_SUCCESS,
  GET_PLAN_ERROR,
  RESET_GET_PLAN,
} from "../../types/plan/get-one";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_PLAN:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case GET_PLAN_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case GET_PLAN_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_GET_PLAN:
      return { ...initialState };
    default:
      return state;
  }
};

export default reducers;
